import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import loginHero from "../assets/home/login-logo.svg";
import axiosInstance from "../apiInstances/axiosInstance";
import { MdOutlineMail } from "react-icons/md";
import homeLogo from "../assets/home/home.svg";

const ForgotPasswordForm = () => {
  const navigate = useNavigate();

  const [fields, setFields] = useState({
    email: "",
  });

  const onChangeInput = (e) => {
    const value = e.target.value.trim();
    const name = e.target.name;

    setFields({
      ...fields,
      [name]: value,
    });
  };

  const onSendEmail = async () => {
    if (!fields.email) {
      toast.error("Please enter your email");
      return;
    }

    const encryptedData = JSON.stringify({
      email: fields.email,
      role: "user",
    });

    try {
      const res = await axiosInstance.post("forgotPassword", encryptedData);

      if (res?.data?.status) {
        toast.success(res?.data?.message);
        setFields({ email: "" });
        navigate("/log-in");
      } else {
        toast.error(res?.data?.message);
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const InputBox =
    "w-full text-sm rounded-full border border-[#E5E7EB] py-3.5 sm:py-4 pl-11 pr-4 outline-none focus:border-[#097FE6] focus:ring-none focus:ring-[#097FE6]";

  const pillPrimary =
    "w-full flex items-center justify-center gap-2 rounded-full bg-[#097FE6] hover:bg-[#0866c4] text-white py-3.5 text-sm sm:text-base font-medium transition";

  return (
    <section className="min-h-screen flex flex-col lg:flex-row bg-white">
      <div className="order-1 flex flex-1 justify-center items-center flex-col lg:order-none lg:w-1/2 lg:min-h-screen px-4 xl:pl-24 pt-8 pb-10 lg:py-12">
        <button
          type="button"
          onClick={() => navigate("/")}
          className="shrink-0 self-center xl:mt-0 mt-10 xl:self-start mb-6 rounded-md outline-none focus-visible:ring-2 focus-visible:ring-[#097FE6] focus-visible:ring-offset-2 flex items-center gap-2"
          aria-label="Go to home"
        >
          <img
            src={homeLogo}
            alt="My Real Estate"
            className="h-8 w-auto max-w-[50px] object-left object-contain cursor-pointer -mt-2"
          />
          <p className="text-xl font-semibold text-[#000929]">
            myrealestate-ng.com
          </p>
        </button>
        <div className="flex flex-1 flex-col justify-center w-full max-w-md mx-auto lg:mx-0">
          <h1 className="xl:text-left text-center text-2xl sm:text-[40px] font-semibold text-[#000929] tracking-tight mb-8 sm:mb-10">
            Forgot your password?
          </h1>
          <p className="text-sm text-[#6B7280] xl:text-left text-center mb-4">
            Enter your registered email and we&apos;ll send you reset instructions.
          </p>

          <button
            type="button"
            className="text-sm text-[#097FE6] font-medium mb-6 self-start hover:underline w-full text-left"
            onClick={() => navigate("/log-in")}
          >
            ← Back to login
          </button>

          <div className="relative w-full mb-4">
            <input
              type="email"
              className={InputBox}
              placeholder="Email"
              name="email"
              value={fields.email}
              onChange={onChangeInput}
              autoComplete="email"
              onKeyDown={(e) => e.key === "Enter" && onSendEmail()}
            />
            <MdOutlineMail className="absolute top-1/2 -translate-y-1/2 left-4 text-[#9CA3AF] text-xl" />
          </div>

          <button type="button" className={pillPrimary} onClick={onSendEmail}>
            Send reset link
          </button>

          <button
            type="button"
            className="mt-4 w-full text-sm font-semibold text-[#097FE6] underline underline-offset-2 decoration-[#097FE6] hover:text-[#0866c4] hover:decoration-[#0866c4] text-center"
            onClick={() => navigate("/")}
          >
            Back to home
          </button>

        </div>

        <p className="mt-auto pt-6 xl:pt-10 text-xs sm:text-sm text-[#9CA3AF] max-w-md mx-auto lg:mx-0 lg:max-w-none xl:text-left text-center">
          By continuing, you agree to our{" "}
          <span className="underline text-[#000929] cursor-pointer">Terms of Service</span>
          {" "}and{" "}
          <span className="underline text-[#000929] cursor-pointer">Privacy Policy</span>
          .
        </p>
      </div>

      <div
        className="order-2 w-full min-h-[240px] sm:min-h-[320px] lg:order-none lg:w-1/2 lg:min-h-screen items-center justify-center px-8 py-10 lg:p-12 bg-gradient-to-l from-[#097FE6] to-[#FFFFFF] xl:flex hidden"
        aria-hidden
      >
        <img
          src={loginHero}
          alt=""
          className="w-full max-w-[min(100%,420px)] lg:max-w-[min(100%,614px)] h-auto object-contain select-none pointer-events-none"
        />
      </div>
    </section>
  );
};

export default ForgotPasswordForm;
